import {Injectable} from '@angular/core';
import {ProduitDeclinaisonDTO} from '../../dtos/produit-declinaison-dto';
import { HttpClient, HttpParams } from '@angular/common/http';
import {ProduitRouteMapService} from './produit-routemap.service';
import {Observable, Subject} from 'rxjs';
import {UtilsService} from '../../utils/utils.service';
import {CompoDTO} from '../../dtos/ciqual/compo-dto';
import {catchError} from 'rxjs/operators';
import {ApportNutritionnelDTO} from '../../dtos/apport-nutritionnel-dto';
import {ProduitApportNutritionnelDTO} from '../../dtos/produit-apportnutritionnel-dto';
import {AlimDTO} from "../../dtos/ciqual/alim-dto";


export const URL_GET_CIQUAL_KEYWORD = `dolrest/ciqual/alim/findByKeywordsAlimNomFrAnd`;
export const URL_GET_COMPO_ALIM_ID = `dolrest/ciqual/compo/findCompoByAlimId`;


@Injectable()
export class CiqualService {


  private subjectAlimDTO = new Subject<Report>();
  subjectAlimDTO$ = this.subjectAlimDTO.asObservable();

  private subjectOpenSearchDialog = new Subject<ProduitDeclinaisonDTO[]>();
  openSearchDialog$ = this.subjectOpenSearchDialog.asObservable();

  private subjectFindCompByAlimID = new Subject<CompoDTO[]>();
  subjectFindCompByAlimID$ = this.subjectFindCompByAlimID.asObservable();


  constructor(private http: HttpClient,
              private produitRouteMapService: ProduitRouteMapService,
              private utils: UtilsService) {
  }

  public save = (listProduitDeclinesDTO: ProduitDeclinaisonDTO[]): Observable<ProduitDeclinaisonDTO[]> => {
    let url = this.produitRouteMapService.getSaveProduitsApportsNutritionnelsSLink();
    return this.http.post<ProduitDeclinaisonDTO[]>(url, listProduitDeclinesDTO)
      .pipe(
        catchError(error => this.utils.handleError(error))
      )


  };

  announceAlimDTO = (report: any) => {
    this.subjectAlimDTO.next(report);
  };

  /**
   *
   * @param {number} alimId ID de l'Alim recherché.
   * @returns {Observable<CompoDTO[]>}
   */
  findCompoListByAlimId = (alimId: number): Observable<CompoDTO[]> => this.http.get(URL_GET_COMPO_ALIM_ID, {
    params: new HttpParams()
      .set('alimId', alimId + '')
  }).pipe(
    catchError(error => this.utils.handleError(error, true))
  );

  findApportNutritionnelByConstId = (apportNutritionnelDTOList: ApportNutritionnelDTO[], constId: number): ApportNutritionnelDTO => {
    let response: ApportNutritionnelDTO = null;

    for (let apportNutritionnelDTO of apportNutritionnelDTOList) {
      if (apportNutritionnelDTO.constId === constId) {
        response = apportNutritionnelDTO;
        break;
      }
    }

    return response;
  };


  findByKeywordsAlimNomFrAnd = (strKeyWords: string) => this.http.get(URL_GET_CIQUAL_KEYWORD, {
    params: new HttpParams()
      .set('strKeyWords', strKeyWords + '')
  }).pipe(
    catchError(error => this.utils.handleError(error, true))
  );


  announceOpenSearchDialog = (produitsDeclines: ProduitDeclinaisonDTO[]) => {
    this.subjectOpenSearchDialog.next(produitsDeclines);
  };

  /**
   * Teneur (pour 100g) d'un apport nutritionnel au sein d'une liste de {@link ProduitApportNutritionnelDTO}.
   * Le rapprochement se fait par constId, qui est l'identifiant CIQUAL stable du constituant.
   */
  getTeneur = (produitApportNutritionnelList: ProduitApportNutritionnelDTO[], apportNutritionnelDTO: ApportNutritionnelDTO): number => {
    for (const produitApportNutritionnel of produitApportNutritionnelList) {
      if (produitApportNutritionnel.apportNutritionnel.constId === apportNutritionnelDTO.constId) {
        return produitApportNutritionnel.teneur;
      }
    }
    return null;
  };

  /**
   * Quantité d'un apport nutritionnel pour la déclinaison de produit passée en paramètre.
   * - produit fabriqué avec un poids net de recette renseigné : la quantité est ramenée au poids réel de la portion (totalPoidsNetRecetteUT).
   * - sinon : la quantité est calculée sur le poids brut, via le ratio unité technique (valeur pour 1kg, donc *10 pour repasser en 100g).
   */
  getQuantite = (produitDeclinaisonDTO: ProduitDeclinaisonDTO, apportNutritionnelDTO: ApportNutritionnelDTO, produitApportNutritionnelList: ProduitApportNutritionnelDTO[]): number => {
    const teneur100g = this.getTeneur(produitApportNutritionnelList, apportNutritionnelDTO);
    if (this.utils.isNullOrEmpty(teneur100g)) {
      return null;
    }

    const quantiteSurPoidsBrut = produitDeclinaisonDTO.ratioUniteTechnique * teneur100g * 10;
    const quantite = produitDeclinaisonDTO.fabrique && !this.utils.isNullOrEmpty(produitDeclinaisonDTO.totalPoidsNetRecetteUT)
      ? produitDeclinaisonDTO.totalPoidsNetRecetteUT * teneur100g / 100
      : quantiteSurPoidsBrut;

    return parseFloat(quantite.toPrecision(9));
  };
}

export interface Report {
  selected : AlimDTO;
  selectedProduitDeclinesId: number[] | null;
}
